/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1CoachApplicationStatus } from './V1CoachApplicationStatus'
import {
    V1CoachApplicationStatusFromJSON,
    V1CoachApplicationStatusFromJSONTyped,
    V1CoachApplicationStatusToJSON,
    V1CoachApplicationStatusToJSONTyped
} from './V1CoachApplicationStatus'
import type { V1ApplicationKind } from './V1ApplicationKind'
import {
    V1ApplicationKindFromJSON,
    V1ApplicationKindFromJSONTyped,
    V1ApplicationKindToJSON,
    V1ApplicationKindToJSONTyped
} from './V1ApplicationKind'

/**
 *
 * @export
 * @interface V1CoachApplication
 */
export interface V1CoachApplication {
    /**
     *
     */
    id?: string
    /**
     *
     */
    status: V1CoachApplicationStatus
    /**
     *
     */
    kind?: V1ApplicationKind
    /**
     *
     */
    applicantId?: string
    /**
     *
     */
    displayName?: string
    /**
     *
     */
    specialization?: string
    /**
     *
     */
    experienceYears?: number
    /**
     *
     */
    languages?: Array<string>
    /**
     *
     */
    about?: string
    /**
     *
     */
    socialLink?: string
    /**
     *
     */
    certificationsLink?: string
    /**
     *
     */
    email?: string
    /**
     *
     */
    contactName?: string
    /**
     *
     */
    phone?: string
    /**
     *
     */
    address?: string
    /**
     *
     */
    reviewNotes?: string
    /**
     *
     */
    created?: string
    /**
     *
     */
    updated?: string
}

/**
 * Check if a given object implements the V1CoachApplication interface.
 */
export function instanceOfV1CoachApplication(
    value: object
): value is V1CoachApplication {
    if (!('status' in value) || value['status'] === undefined) return false
    return true
}

export function V1CoachApplicationFromJSON(json: any): V1CoachApplication {
    return V1CoachApplicationFromJSONTyped(json, false)
}

export function V1CoachApplicationFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1CoachApplication {
    if (json == null) {
        return json
    }
    return {
        id: json['id'] == null ? undefined : json['id'],
        status: V1CoachApplicationStatusFromJSON(json['status']),
        kind:
            json['kind'] == null
                ? undefined
                : V1ApplicationKindFromJSON(json['kind']),
        applicantId:
            json['applicantId'] == null ? undefined : json['applicantId'],
        displayName:
            json['displayName'] == null ? undefined : json['displayName'],
        specialization:
            json['specialization'] == null ? undefined : json['specialization'],
        experienceYears:
            json['experienceYears'] == null
                ? undefined
                : json['experienceYears'],
        languages: json['languages'] == null ? undefined : json['languages'],
        about: json['about'] == null ? undefined : json['about'],
        socialLink: json['socialLink'] == null ? undefined : json['socialLink'],
        certificationsLink:
            json['certificationsLink'] == null
                ? undefined
                : json['certificationsLink'],
        email: json['email'] == null ? undefined : json['email'],
        contactName:
            json['contactName'] == null ? undefined : json['contactName'],
        phone: json['phone'] == null ? undefined : json['phone'],
        address: json['address'] == null ? undefined : json['address'],
        reviewNotes:
            json['reviewNotes'] == null ? undefined : json['reviewNotes'],
        created: json['created'] == null ? undefined : json['created'],
        updated: json['updated'] == null ? undefined : json['updated']
    }
}

export function V1CoachApplicationToJSON(json: any): V1CoachApplication {
    return V1CoachApplicationToJSONTyped(json, false)
}

export function V1CoachApplicationToJSONTyped(
    value?: V1CoachApplication | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        id: value['id'],
        status: V1CoachApplicationStatusToJSON(value['status']),
        kind: V1ApplicationKindToJSON(value['kind']),
        applicantId: value['applicantId'],
        displayName: value['displayName'],
        specialization: value['specialization'],
        experienceYears: value['experienceYears'],
        languages: value['languages'],
        about: value['about'],
        socialLink: value['socialLink'],
        certificationsLink: value['certificationsLink'],
        email: value['email'],
        contactName: value['contactName'],
        phone: value['phone'],
        address: value['address'],
        reviewNotes: value['reviewNotes'],
        created: value['created'],
        updated: value['updated']
    }
}
